import * as _ from "lodash";

import * as React from "react";
import { FormattedNumber, FormattedMessage } from "react-intl";

type Props = {
    amount: {
        amount: number;
        currency: string;
    };
    unitIndicatorKey?: string | null;
    labelKey?: string | null;
    className?: string | null;
};

function MoneyAmount(props: Props) {
    const amount = props.amount;
    const className = props.className || "";
    const labelKey = props.labelKey || "";
    const unitIndicatorKey = props.unitIndicatorKey || "";
    if (!amount || _.isNull(amount.amount) || amount.currency === "XXX") {
        return (
            <span className={"no-amount " + className}>
                <FormattedMessage id="NOT_AVAILABLE_ABBREVIATION" />
            </span>
        );
    }

    // JPY currency needs 0 decimal places instead of 2
    const format = amount.currency === "JPY" ? "currencyJPY" : "currency";
    const price = <FormattedNumber value={amount.amount} format={format} currency={amount.currency} />;
    const unitIndicator = unitIndicatorKey !== "" ? <FormattedMessage id={unitIndicatorKey} /> : null;
    const perUnit = unitIndicator ? <span> / {unitIndicator}</span> : null;
    if (labelKey !== "") {
        return (
            <span className={className}>
                <FormattedMessage id={labelKey} values={{ price: price, perUnit: perUnit }} />
            </span>
        );
    } else {
        return (
            <span className={className}>
                {price}
                {perUnit}
            </span>
        );
    }
}

export default MoneyAmount;
